import React, { useEffect } from "react";

const Modal = ({
  isOpen,
  onClose,
  title,
  children,
  footer,
  primaryButtonText,
  primaryButtonOnClick,
  primaryButtonVariant = "primary", // "primary" | "danger" | "success"
  secondaryButtonText,
  secondaryButtonOnClick,
  showCancelButton = true,
  cancelButtonText = "Hủy",
  maxWidth = "600px",
  maxHeight = "90vh",
}) => {
  // Lock body scroll while modal open
  useEffect(() => {
    if (isOpen) {
      const prev = document.body.style.overflow;
      document.body.style.overflow = "hidden";
      return () => {
        document.body.style.overflow = prev;
      };
    }
  }, [isOpen]);

  const getButtonStyle = (variant) => {
    const styles = {
      primary: "bg-blue-600 hover:bg-blue-700 text-white",
      danger: "bg-red-600 hover:bg-red-700 text-white",
      success: "bg-green-600 hover:bg-green-700 text-white",
    };
    return styles[variant] || styles.primary;
  };
  if (!isOpen) return null;

  const renderFooter = () => {
    if (footer) {
      return <div className="px-6 py-4 border-t border-gray-200">{footer}</div>;
    }

    if (!primaryButtonText && !secondaryButtonText && !showCancelButton) {
      return null;
    }

    return (
      <div className="px-6 py-4 border-t border-gray-200 flex justify-end gap-3">
        {showCancelButton && (
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50 transition-colors font-medium"
          >
            {cancelButtonText}
          </button>
        )}
        {secondaryButtonText && (
          <button
            onClick={secondaryButtonOnClick}
            className="px-4 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50 transition-colors font-medium"
          >
            {secondaryButtonText}
          </button>
        )}
        {primaryButtonText && (
          <button
            onClick={primaryButtonOnClick}
            className={`px-4 py-2 rounded-lg transition-colors font-medium ${getButtonStyle(
              primaryButtonVariant,
            )}`}
          >
            {primaryButtonText}
          </button>
        )}
      </div>
    );
  };

  return (
    <div className="fixed inset-0 z-[70]">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/50"
        onClick={onClose}
        aria-hidden
      />

      {/* Dialog */}
      <div className="relative z-[71] w-full h-full flex items-center justify-center p-4">
        <div
          className="bg-white rounded-2xl shadow-2xl w-full flex flex-col"
          style={{ maxWidth, maxHeight }}
        // IMPORTANT: để dropdown/panel không bị cắt bởi wrapper
        >
          {/* Header */}
          <div className="px-6 py-5 border-b border-gray-200 flex items-center justify-between rounded-t-2xl">
            <h2 className="text-xl font-bold text-gray-900">{title}</h2>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600 transition-colors w-6 h-6 flex items-center justify-center"
              aria-label="Close"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M18 6L6 18M6 6l12 12" />
              </svg>
            </button>
          </div>

          {/* Body */}
          <div className="flex-1 overflow-y-auto">
            {/* Không bọc overflow-hidden ở container ngoài nữa */}
            {children}
          </div>

          {/* Footer */}
          {renderFooter()}
        </div>
      </div>
    </div>
  );
};

export default Modal;
